import React, { Component } from "react";

class Brands extends Component {
    render() {
        return (
            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h2 className="section-heading h1 text-dark mb-15">I nostri sponsor</h2>
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                            <img className="img-fluid mt-40" src={process.env.PUBLIC_URL + '/assets/images/Partner/b_side.png'} alt="" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                            <img className="img-fluid mt-40" src={process.env.PUBLIC_URL + '/assets/images/Partner/emergency.png'} alt="" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                            <img className="img-fluid mt-40" src={process.env.PUBLIC_URL + '/assets/images/Partner/franchigia_firenze.png'} alt="" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                            <img className="img-fluid mt-40" src={process.env.PUBLIC_URL + '/assets/images/Partner/ing_project.png'} alt="" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                            <img className="img-fluid mt-40" src={process.env.PUBLIC_URL + '/assets/images/Partner/logo_corallina.png'} alt="" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                            <img className="img-fluid mt-40" src={process.env.PUBLIC_URL + '/assets/images/Partner/lupi_auto.png'} alt="" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Brands;